/**
 * 全局把 @nuxtjs/i18n 的 SEO 标签（hreflang / canonical / og:url / og:locale）
 * 注入到 head。i18n v8 的 seo:true 不自动写入，必须显式调 useLocaleHead()。
 *
 * 单一来源：i18n.baseUrl（= NEXT_PUBLIC_SITE_URL）。
 */
export default defineNuxtPlugin(() => {
  const head = useLocaleHead({
    addDirAttribute: true,
    addSeoAttributes: true,
    identifierAttribute: 'id',
  });

  useHead(() => ({
    htmlAttrs: head.value.htmlAttrs ?? {},
    link: [...(head.value.link ?? [])],
    meta: [...(head.value.meta ?? [])],
  }));
});
